module.exports = __webpack_public_path__ + "media/success_sweepstakes/wave-tile-b4bcec4c.png";